import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import CheckboxCell from "../../../common/interactive/CheckboxCell"
import { caseQuickUpdate } from "../../../../lib/fetchApi"
import { notificationActions } from "../../../../store/notifications"
import MajorMedDepartmentDrawer from "./MajorMedDepartmentDrawer"
import InputBoxCurrency from "../../../common/interactive/InputBoxCurrency"
import { caseActions } from "../../../../store/case"

import classes from './MajorMedDepartment.module.css'
import InputBox from "../../../common/interactive/InputBox"

export default function MajorMedDepartment({itemData, majorMedData}) {
    const dispatch = useDispatch()
    
    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase)

    const [showDetails, setShowDetails] = useState(false)

    const [hasContent, setHasContent] = useState(null)


    useEffect(() => {
        if (majorMedData && majorMedData.major_med_departments && majorMedData.major_med_departments.length > 0) {
            majorMedData.major_med_departments.forEach(element => {
                if (itemData.id == element.department_id) {
                    setHasContent(element)
                }
            });
        }
    }, [])

    function showDetailshandler() {
        setShowDetails(prevState => prevState = !prevState)
    }


    const updateHandler = async (data) => {
        let reqBody = {
            type: data.identifier.type,
            type_id: data.identifier.type_id,
            fields: {
                department_id: itemData.id,
                [data.identifier.field] : data.data.value,
            }
        }

        let update = await caseQuickUpdate(userToken, activeCase.case.id, reqBody)

        if (update && update.errorMessage) {
            dispatch(notificationActions.setError(update))
        } else {            

            let dispatchObj = {
                folder: data.identifier.folder,
                itemId: data.identifier.type_id,
                departmentId: data.identifier.department_id,
                data: update
            }
    
    
            dispatch(caseActions.setDepartmentOnMajorMed(dispatchObj))
        }        
            
    }

    const [showInactive, setShowInactive] = useState(false)

    function showActiveOnlyHandler(event) {
        if (event.value) {
            setShowInactive(true)
        } else {
            setShowInactive(false)
        }
    }

    return <>
        <tr >
            <td onClick={showDetailshandler} className={`${classes.department_item}`} >
                <div className={`${classes.drawer_trigger_mark} ${showDetails ? classes.is_opened : ''}`}>
                    <i className='ti ti-chevron-right'></i>
                    {itemData.name}
                </div>
            </td>
            {hasContent && <>
                <td>
                    <InputBox bkTransparent={true} currentValue={hasContent.no_visits} setStyle={'simple'} action={updateHandler} identifier={{type: 'case_major_med_departments', field: 'no_visits', type_id: majorMedData.id, department_id: itemData.id, folder: 'major_meds'}}/>
                </td>
                <td><InputBoxCurrency textRight={true} placeholder={'Limits'} currentValue={hasContent.limit} action={updateHandler} identifier={{type: 'case_major_med_departments', field: 'limit', type_id: majorMedData.id, department_id: itemData.id, folder: 'major_meds'}}/></td>
                <td>
                    <CheckboxCell checked={hasContent.pre_auth} name={'pre_auth'} action={updateHandler} direction={'reverse'} identifier={{type: 'case_major_med_departments', field: 'pre_auth', type_id: majorMedData.id, department_id: itemData.id, folder: 'major_meds'}}/>
                </td>                
            </>}
            {!hasContent && <>
                <td><InputBox bkTransparent={true} currentValue={itemData.no_visits} setStyle={'simple'} action={updateHandler} identifier={{type: 'case_major_med_departments', field: 'no_visits', type_id: majorMedData.id, department_id: itemData.id, folder: 'major_meds'}}/></td>
                <td><InputBoxCurrency textRight={true} placeholder={'Limits'} currentValue={itemData.limit} action={updateHandler} identifier={{type: 'case_major_med_departments', field: 'limit', type_id: majorMedData.id, department_id: itemData.id, folder: 'major_meds'}}/></td>
                <td><CheckboxCell checked={false} name={'pre_auth'}  action={updateHandler} direction={'reverse'} identifier={{type: 'case_major_med_departments', field: 'pre_auth', type_id: majorMedData.id, department_id: itemData.id, folder: 'major_meds'}}/></td>
            </>}
            <td>
                <CheckboxCell checked={true} name={'show_active_only'} action={showActiveOnlyHandler} direction={'reverse'} identifier={{type: 'case_major_med_departments', field: 'show_active_only', type_id: majorMedData.id, department_id: itemData.id, folder: 'major_meds'}}/>
            </td>
        </tr>
        {showDetails && <tr>
            <td colSpan={5}>
                <MajorMedDepartmentDrawer departmentId={itemData.id} majorMedData={majorMedData} showInactive={showInactive}/>
            </td>    
        </tr>}
    </>
}